import type { Endpoint } from '../services/apiClient.types';

/**
 * Query keys for the OSAT feature.
 * Ensures consistency for React Query caching.
 */
export enum OsatQueryKeys {
  SUBMIT_RESPONSE = 'osatSubmitResponse',
  ELIGIBILITY = 'osatEligibility',
}

/**
 * OSAT endpoints (Foundation API, base `VITE_FOUNDATION_API_BASE_URL`).
 * Route-map convention mirrors `gesRoutes.ts` / `alertBarRoutes.ts`.
 */
export const OSAT_API_ROUTES = {
  SUBMIT_RESPONSE: (baseUrl: string): Endpoint => ({
    url: `${baseUrl}/v1.0/osat/responses`,
    queryKey: OsatQueryKeys.SUBMIT_RESPONSE,
  }),
  ELIGIBILITY: (baseUrl: string): Endpoint => ({
    url: `${baseUrl}/v1.0/osat/eligibility`,
    queryKey: OsatQueryKeys.ELIGIBILITY,
  }),
  DISMISS: (baseUrl: string): string => `${baseUrl}/v1.0/osat/dismiss`,
} as const;
